export class AnalyteCareCouponDto {
  public name: string;
  public code: string;
  public value: number;

  public constructor(name: string, code: string, value: number) {
    this.name = name;
    this.code = code;
    this.value = value;
  }
}
